function findMax(arr, key) {
  let _max = null;

  arr.forEach((t) => {
    if (t[key] && `${t[key]}` !== '') {
      let _value = `${t[key]}`.replace(/,/g, '');
      if (!isNaN(_value)) {
        _value = parseFloat(_value);
        if (_max === null || _value > _max) {
          _max = _value;
        }
      }
    }
  });

  return _max;
}

function findMin(arr, key) {
  let _min = null;

  arr.forEach((t) => {
    if (t[key] && `${t[key]}` !== '') {
      let _value = `${t[key]}`.replace(/,/g, '');
      if (!isNaN(_value)) {
        _value = parseFloat(_value);
        if (_min === null || _value < _min) {
          _min = _value;
        }
      }
    }
  });

  return _min;
}

module.exports = {
  findMax,
  findMin,
};
